import BASIC from './basic';

const LIGHT = {
  ...BASIC,
}

export default LIGHT;